import { useTranslation } from 'next-i18next'

function PreviewWarning() {
    const { t } = useTranslation('common')

    return (
        <div
            style={{
                maxWidth: '600px',
                margin: '32px auto',
                border: '2px solid #b8410a',
                borderRadius: '8px',
                background: '#fdf5f0',
                padding: '16px',
                boxSizing: 'border-box',
                lineHeight: '1.5',
            }}
        >
            <h2 style={{ paddingBottom: '16px' }}>{t('warningBox.title')}</h2>
            <p>{t('warningBox.body')}</p>
        </div>
    )
}

export { PreviewWarning }
